import {
  BulkPatchDocumentTemplateType,
  CreateDocumentTemplateType,
  DeleteDocumentTemplateType,
  FileUploadForPreSignedUrlGenerateTask,
  getByIdDocumentTemplate,
  getByIdDocumentTemplateWhileCreation,
  PatchDocumentTemplateType,
  PayloadGetDocumentTemplateByPageType,
} from '../types/documentTemplate.types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

const getAllDocumentTemplateApi = async (
  payload: PayloadGetDocumentTemplateByPageType
) => {
  const response = !payload?.searchText
    ? await axiosInstance.post(
        `${
          API_END_POINT.TEMPLATE
        }/v1/document-template/filter/advance?sort=enabled,DESC&page=${
          payload.page - 1
        }&size=${payload.rowsPerPage}`,
        payload?.filter,
        {
          params: {
            sort: payload?.sort,
          },
        }
      )
    : await axiosInstance.post(
        `${
          API_END_POINT.TEMPLATE
        }/v1/document-template/filter/advance?sort=enabled,DESC&page=${
          payload.page - 1
        }&size=${payload.rowsPerPage}&searchText=${payload.searchText}`,
        payload?.filter,
        {
          params: {
            sort: payload?.sort,
          },
        }
      )
  return response
}
const createDocumentTemplateApi = async (
  payload: CreateDocumentTemplateType
) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v1/document-template`,
    payload
  )
}

const fetchDocumentTemplateByIdApi = async (
  payload: getByIdDocumentTemplate
) => {
  return await axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/document-template/document/${payload.id}`
  )
}

const previewDocumentTemplateByIdWhileCreationApi = async (
  payload: getByIdDocumentTemplateWhileCreation
) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v1/communications/preview-dynamic-doc/${payload.id}`,
    {
      doc_content: payload.body,
      program_id: payload.program,
      placeholder_mapping: payload.placeholders,
      id: payload.id,
      body_type: payload.body_type,
    }
  )
}

const previewDocumentPdfWhileCreation = async (
  payload: getByIdDocumentTemplateWhileCreation
) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v2/communications/download-url-base64`,
    {
      case_id: payload?.id,
      body: payload.body,
      program_id: payload.program,
      header: payload?.header,
      footer: payload?.footer,
      editable_fields: [
        {
          type: 0,
          editableValues: {},
        },
      ],
    }
  )
}

const updateDocumentTemplateApi = async (
  payload: CreateDocumentTemplateType
) => {
  return await axiosInstance.put(
    `${API_END_POINT.TEMPLATE}/v1/document-template`,
    payload
  )
}

const saveAsDraftDocumentTemplateApi = async (
  payload: CreateDocumentTemplateType
) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v1/document-template/save-as-draft`,
    payload
  )
}

const enableDisabletogglerDocumentTemplateApi = async (
  payload: PatchDocumentTemplateType
) => {
  return await axiosInstance.put(
    `${API_END_POINT.TEMPLATE}/v1/document-template/${payload.id}?enabled=${payload.enabled}`,
    {}
  )
}
const enableDisableBulktogglerDocumentTemplateApi = async (
  payload: BulkPatchDocumentTemplateType
) => {
  return await axiosInstance.put(
    `${API_END_POINT.TEMPLATE}/v1/document-template/enable?enable=${payload.enabled}`,
    payload.documentTemplateIds
  )
}
const deleteDocumentTemplateApi = async (
  payload: DeleteDocumentTemplateType
) => {
  return await axiosInstance.delete(
    `${API_END_POINT.TEMPLATE}/v1/document-template/${payload.id}`
  )
}

const getServicesCorrespondingToProgramApi = async (id: number) => {
  return await axiosInstance.get(`${API_END_POINT.CORE}programs/${id}/services`)
}

const getSearchedDocumentTemplatesApi = async (
  page?: number,
  limit?: number,
  filter?: {
    search_key: string
    operator: string
    search_value: number[] | string[] | boolean[]
  }[]
) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v1/document-template/filter/advance?page=${page}&size=${limit}`,
    {
      fields: null,
      search_criteria: filter,
    }
  )
}

const fetchPresignedURLSingleUploadAtGenerateDocument = async (
  payload: FileUploadForPreSignedUrlGenerateTask[]
) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER}entities/files/generate-upload-presigned-url`,
    payload
  )
}

const stringFilterApiURLDynamicDocument = `${API_END_POINT.TEMPLATE}/dropdown/filter-data/document_template/`

export {
  getAllDocumentTemplateApi,
  createDocumentTemplateApi,
  fetchDocumentTemplateByIdApi,
  updateDocumentTemplateApi,
  saveAsDraftDocumentTemplateApi,
  enableDisabletogglerDocumentTemplateApi,
  deleteDocumentTemplateApi,
  enableDisableBulktogglerDocumentTemplateApi,
  previewDocumentTemplateByIdWhileCreationApi,
  getServicesCorrespondingToProgramApi,
  stringFilterApiURLDynamicDocument,
  previewDocumentPdfWhileCreation,
  getSearchedDocumentTemplatesApi,
  fetchPresignedURLSingleUploadAtGenerateDocument,
}
